import withErrorBoundary from '@concur/core-ui-shell/lib/hoc/withErrorBoundary';
import compose from '@concur/core-ui-shell/lib/utils/compose';
import { withFormatter } from '@concur/nui-intl-runtime';
import classnamesBind from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import Logo from './Logo';

const NavLogo = ({
    styles,
    className,
    cssBlock,
    descriptionId,
    formatter,
    isOpusUser,
    brandingLogoUrl,
    brandingLogoData,
    companyName,
    configOptions,
}) => {
    const classnames = classnamesBind.bind(styles);
    return (
        <>
            <Logo
                styles={styles}
                cssBlock={cssBlock}
                className={className}
                data-test="logo"
                hideTitle
                isOpusUser={isOpusUser}
                brandingLogoUrl={brandingLogoUrl}
                brandingLogoData={brandingLogoData}
                companyName={companyName}
                configOptions={configOptions}
            />
            <span
                id={descriptionId}
                className={classnames(
                    `${cssBlock}__screen-reader-only`,
                )}
            >
                {formatter.formattedMessage({ id: 'CoreUI.SAPConcurLogo' })}
            </span>
        </>
    );
};

NavLogo.displayName = 'NavLogo';

NavLogo.propTypes = {
    descriptionId: PropTypes.string,
    className: PropTypes.string,
    cssBlock: PropTypes.string,
    styles: PropTypes.object,
    isOpusUser: PropTypes.bool,
    brandingLogoUrl: PropTypes.string,
    brandingLogoData: PropTypes.string,
    companyName: PropTypes.string,
    configOptions: PropTypes.object,
};

export default compose(
    withFormatter,
    withErrorBoundary,
)(NavLogo);
